import React from 'react';

const uploadLabel = (uploads) => {
  if (uploads.length === 1) {
    return `Uploading ${uploads[0].filename || 'attachment'}…`;
  }
  return `Uploading ${uploads.length} files…`;
};

const AttachmentUploadStatus = ({ uploads = [] }) => {
  if (!uploads.length) return null;

  return (
    <div
      className="mind-map-notification mind-map-notification--upload"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className="mind-map-upload-spinner" aria-hidden="true" />
      <span>{uploadLabel(uploads)}</span>
    </div>
  );
};

export default AttachmentUploadStatus;
